import QuizIcon from '@material-ui/icons/Assignment';
import PersonalityQuizReportsList from './components/PersonalityQuizReportsList';
import { APP_TYPES, roles } from '../../../config/constants';

const options = {
  appTypes: [APP_TYPES.ALL],
  allowedRoles: [roles.ADMIN, roles.JTI_TEAM],
  label: 'Personality Quiz',
  subMenuName: 'reports',
};

export default {
  list: PersonalityQuizReportsList,
  icon: QuizIcon,
  name: 'admin/reports/personality-quizzes',
  options,
};
